__webpack_require__.p = "/badge-generator/";